import { useCallback } from 'react';

function doScroll(element: Element) {
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export const useScrollToStep = () => {
  const scrollToStep = useCallback((index: any) => {
    const id = `step-${index}`;
    const element = document.getElementById(id);

    if (element) {
      // step is open and visible
      doScroll(element);
      return;
    }

    // else the step is closed, find and expand via horrible dom hack
    const candidates = document.querySelectorAll('[data-completed-steps]');
    for (const candidate of candidates) {
      const steps = candidate.getAttribute('data-completed-steps')?.split(',').map(Number);
      if (steps?.includes(index)) {
        const clickable = candidate.querySelector<HTMLButtonElement>(
          '[data-state="closed"]:has([data-icon="chevron-down"])',
        );
        if (clickable) {
          clickable.click();
          requestIdleCallback(() => doScroll(document.getElementById(id)!));
          break;
        }
      }
    }
  }, []);

  return scrollToStep;
};
